export default class WaveShape {
  constructor(points, color) {
    this.points = points
    this.color = color
  }

  render(ctx, width, height) {
    ctx.save()
    ctx.lineWidth = 2
    ctx.strokeStyle = '#fff'
    ctx.fillStyle = 'rgba(255, 255, 255, 0)'
    this.points.forEach((point) => {
      ctx.beginPath()
      ctx.font = '14px Arial'
      ctx.arc(point.x, point.y, 2, 0, 2 * Math.PI)
      ctx.closePath()
      ctx.fill()
    })
    ctx.fillStyle = this.color
    ctx.beginPath()
    ctx.moveTo(this.points[0].x, this.points[0].y)
    this.points.forEach((point, index) => {
      point.y = point.oldY + 35 * Math.sin(point.angle)
      point.angle += point.speed
      const next = this.points[index + 1]
      if (next) {
        const mid = {
          x: (point.x + next.x) / 2,
          y: (point.y + next.y) / 2,
        }
        ctx.quadraticCurveTo(point.x, point.y, mid.x, mid.y)
      }
    })
    ctx.lineTo(width, height)
    ctx.lineTo(0, height)
    ctx.fill()
    ctx.restore()
  }
}
